module.exports = __webpack_public_path__ + "img/Mis clases Icono.c411cf15.svg";